import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import MetricGrid from "@/components/MetricGrid";
import MetricGridSkeleton from "@/components/Skeleton/MetricGridSkeleton";
import TableSkeleton from "@/components/Skeleton/TableSkeleton";
import PATActivityTable from "@/features/person/components/PATActivityTable";
import { STUDENT_PAT_RESULTS_QUERY } from "../../queries";
import { buildPATStatusForMetric } from "../../_utils/patStatus";

export default function StudentPATResultsPage() {
  const { universityId, studentId } = useParams();

  const { data, loading } = useQuery(STUDENT_PAT_RESULTS_QUERY, {
    variables: {
      input: {
        universityLegacyIds: [universityId?.toString() || ""],
        alumni: false,
        search: studentId
      }
    },
    skip: !universityId || !studentId
  });

  const student = data?.universityStudents?.nodes?.[0];
  const patStatus = buildPATStatusForMetric(student?.prospectProgram?.playingAbilityTestStatus);

  if (loading) {
    return (
      <div className="flex flex-col">
        <MetricGridSkeleton cards={1} />
        <TableSkeleton columns={7} rows={3} />
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <MetricGrid
        metrics={[
          {
            label: "PAT Status",
            value: patStatus.value,
            iconName: "sports_golf",
            variant: patStatus.variant
          }
        ]}
        layout="expanded"
      />

      <PATActivityTable
        patStatus={student?.prospectProgram?.playingAbilityTestStatus as any}
        enableNavigation={false}
        body="View all PAT attempts and results associated with this student."
      />
    </div>
  );
}
